import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const language = window.ntLang || 'fi';
const resources = window.ntTranslations || {};

export default i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: language,
    ns: 'dealers',
    defaultNS: 'dealers',

    interpolation: {
      escapeValue: false
    }
  });

i18n.addResourceBundle(language, 'dealers', resources);
